/**
 * this is the response from prismic for the non feed footer data
 * await client.getSingle('non-feed-footer')
 *
 * we would like to load this data, but can't reasonably load data serverside/static for a component at the moment
 * this might be the answer in the future: https://nextjs.org/blog/layouts-rfc#data-fetching
 */
export const document = {
  id: 'YyCKNhMAACIA-miK',
  uid: null,
  url: null,
  type: 'non-feed-footer',
  href: 'https://kittlblog.cdn.prismic.io/api/v2/documents/search?ref=Yy3MUBMAAILYNYCK&q=%5B%5B%3Ad+%3D+at%28document.id%2C+%22YyCKNhMAACIA-miK%22%29+%5D%5D',
  tags: [],
  first_publication_date: '2022-09-13T13:48:49+0000',
  last_publication_date: '2022-09-14T12:20:34+0000',
  slugs: ['nonfeedfooter'],
  linked_documents: [],
  lang: 'en-gb',
  alternate_languages: [],
  data: {
    slices: [
      {
        variation: 'default',
        version: 'sktwi1xtmkfgx8626',
        items: [
          {
            title: 'Editor ',
            route: '/features/editor',
            link: {
              link_type: 'Any',
            },
          },
          {
            title: 'AI',
            route: '/features/ai',
            link: {
              link_type: 'Any',
            },
          },
          {
            title: 'Infinite Canvas ',
            route: '/features/infinite-canvas',
            link: {
              link_type: 'Any',
            },
          },
          {
            title: 'Teams',
            route: '/features/teams',
            link: {
              link_type: 'Any',
            },
          },
          {
            title: 'Fonts',
            route: '/features/fonts',
            link: {
              link_type: 'Any',
            },
          },
          {
            title: 'Mockups',
            route: '/tools/mockups',
            link: {
              link_type: 'Any',
            },
          },
          {
            title: 'Asset Library',
            route: '/features/content-library',
            link: {
              link_type: 'Any',
            },
          },
          {
            title: 'Text Effects',
            route: '/features/text-effects',
            link: {
              link_type: 'Any',
            },
          },
        ],
        primary: {
          title: 'Features',
          route: '/features',
        },
        id: 'non_feed_footer_column$b6e0c4d5-9d6d-4f9f-b4f9-7f2c267ccb3c',
        slice_type: 'non_feed_footer_column',
        slice_label: null,
      },
      {
        variation: 'default',
        version: 'sktwi1xtmkfgx8626',
        items: [
          {
            title: 'For Marketing',
            route: '/solutions/marketing',
            link: {
              link_type: 'Any',
            },
          },
          {
            title: 'For Print on Demand',
            route: '/solutions/print-on-demand',
            link: {
              link_type: 'Any',
            },
          },
          {
            title: 'For Freelancers ',
            route: '/solutions/freelancer',
            link: {
              link_type: 'Any',
            },
          },
          {
            title: 'For Branding ',
            route: '/solutions/branding',
            link: {
              link_type: 'Any',
            },
          },
        ],
        primary: {
          title: 'Solutions',
          route: '/solutions',
        },
        id: 'non_feed_footer_column$208ea473-9f58-4998-aef3-5a7f717fa18c',
        slice_type: 'non_feed_footer_column',
        slice_label: null,
      },
      {
        variation: 'default',
        version: 'sktwi1xtmkfgx8626',
        items: [
          {
            title: 'Discord',
            route: null,
            link: {
              link_type: 'Web',
              url: 'https://discord.gg/kittl',
            },
          },
          {
            title: 'Creators',
            route: '/partners/creators',
            link: {
              link_type: 'Any',
            },
          },
          {
            title: 'Influencers',
            route: '/partners/influencers',
            link: {
              link_type: 'Any',
            },
          },
          {
            title: 'Affiliates',
            route: '/affiliates',
            link: {
              link_type: 'Any',
            },
          },
        ],
        primary: {
          title: 'Community',
          route: '/community',
        },
        id: 'non_feed_footer_column$31fc75c4-e01d-4dae-9052-81dcf35f6c33',
        slice_type: 'non_feed_footer_column',
        slice_label: null,
      },
      {
        variation: 'default',
        version: 'sktwi1xtmkfgx8626',
        items: [
          {
            title: 'Plans',
            route: '/pricing',
            link: {
              link_type: 'Any',
            },
          },
          {
            title: 'For Education',
            route: '/education',
            link: {
              link_type: 'Any',
            },
          },
          {
            title: 'Licensing',
            route: '/licensing',
            link: {
              link_type: 'Any',
            },
          },
          {
            title: 'Help',
            route: '/help',
            link: {
              link_type: 'Any',
            },
          },
          {
            title: 'Blog',
            route: '/blog',
            link: {
              link_type: 'Any',
            },
          },
          {
            title: 'Templates',
            route: '/templates',
            link: {
              link_type: 'Any',
            },
          },
          {
            title: 'Create Designs',
            route: '/create',
            link: {
              link_type: 'Any',
            },
          },
          {
            title: 'Tools',
            route: '/tools',
            link: {
              link_type: 'Any',
            },
          },
        ],
        primary: {
          title: 'Resources',
        },
        id: 'non_feed_footer_column$ff549b0d-e431-48ad-9e56-39f9b2a5ef0f',
        slice_type: 'non_feed_footer_column',
        slice_label: null,
      },
      {
        variation: 'default',
        version: 'sktwi1xtmkfgx8626',
        items: [
          {
            title: 'About us ',
            route: '/about',
            link: {
              link_type: 'Any',
            },
          },
          {
            title: 'Careers ',
            route: '/careers',
            link: {
              link_type: 'Any',
            },
          },
          {
            title: 'Contact ',
            route: '/contact',
            link: {
              link_type: 'Any',
            },
          },
          {
            title: 'Legal Details',
            route: '/legal',
            link: {
              link_type: 'Any',
            },
          },
          {
            title: 'Terms of Use',
            route: '/terms',
            link: {
              link_type: 'Any',
            },
          },
          {
            title: 'Privacy Policy',
            route: '/privacy',
            link: {
              link_type: 'Any',
            },
          },
          {
            title: 'Cookie Policy',
            route: '/cookie-policy',
            link: {
              link_type: 'Any',
            },
          },
        ],
        primary: {
          title: 'Company',
        },
        id: 'non_feed_footer_column$90e7d47d-894a-4b18-8ed8-0e74ab170348',
        slice_type: 'non_feed_footer_column',
        slice_label: null,
      },
    ],
  },
};
